import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'od-group-menu',
  templateUrl: './group-menu.component.html',
  styleUrls: ['./group-menu.component.scss'],
  standalone: false,
})
export class GroupMenuComponent {
  @ViewChild('group', { read: ElementRef }) public group: ElementRef;
  @Input() public loading: boolean;
  @Input() public groupIdActive: number;
  @Input() public groups: Map<number, string>;

  @Output() public removeGroup = new EventEmitter();
  @Output() public groupChange = new EventEmitter<number>();

  public groupMenuOpen = false;

  @HostListener('document:pointerup', ['$event', '$event.target'])
  public handleMenuClose(_event: MouseEvent, targetElement: HTMLElement) {
    if (
      !this.group?.nativeElement.contains(targetElement) &&
      this.groupMenuOpen
    ) {
      this.groupMenuOpen = false;
    }
  }

  public removeGroupClicked() {
    this.removeGroup.emit();
  }

  public get groupActiveLabel() {
    return this.groupIdActive === null ? 'regular' : 'selected';
  }
  public get groupMenuOpenIcon() {
    return this.groupMenuOpen ? 'up' : 'down';
  }

  public toggleGroupMenu() {
    if (this.loading) {
      return;
    }
    this.groupMenuOpen = !this.groupMenuOpen;
  }

  public activeGroup(value: number) {
    this.groupChange.emit(value);
  }
}
